module.exports = __webpack_public_path__ + "img/hourglass.e37e305c.svg";